module.exports = __webpack_public_path__ + "media/images/1200/narcolepsy_moon_mountains-c0038f97125ad3322b656ae23d333574.webp";